import { useState } from 'react';
import styles from './SuggestedActivities.module.css';
import { useEffect } from 'react';
import { API_URL } from '../utils/fatch';
import { useRef } from 'react';
import { useTripInfo } from '../context';
import { Link } from 'react-router-dom';


const sortOptions = [
    {
        id: 1,
        icon: 'recommend',
        name: 'Recommended',
    },
    {
        id: 2,
        icon: 'trending_up',
        name: 'Popularity',
    }, {
        id: 3,
        icon: 'star',
        name: 'Highest Rated',
    }, {
        id: 4,
        icon: 'sort_by_alpha',
        name: 'Name: A to Z',
        icon_2: 'arrow_upward'
    }, {
        id: 5,
        icon: 'sort_by_alpha',
        name: 'Name: Z to A',
        icon_2: 'arrow_downward'
    }
]


export const Suggested_header = (props) => {
    const abortControllerRef = useRef(null);

  const { currentTripId } = useTripInfo();

    const [showCategories, setShowCategories] = useState(true);

    const [searchLoading, setSearchLoading] = useState(false);


    const mainCategories = [
        {
            icon: <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="16px" fill="#000000"><path d="m233-80 54-122q-14-11-27-21.5T235-246q-8 3-15.5 4.5T203-240q-33 0-56.5-23.5T123-320q0-20 8.5-36.5T155-384q-8-23-11-46.5t-3-49.5q0-26 3-49.5t11-46.5q-15-11-23.5-27.5T123-640q0-33 23.5-56.5T203-720q9 0 16.5 1.5T235-714q33-36 75.5-60t90.5-36q5-30 27.5-50t52.5-20q30 0 52.5 20.5T561-810q48 12 90.5 35.5T727-716q8-3 15-4.5t15-1.5q33 0 56.5 23.5T837-642q0 20-8 35.5T807-580q8 24 11 49t3 51q0 26-3 50.5T807-382q14 11 22 26.5t8 35.5q0 33-23.5 56.5T757-240q-8 0-15-1.5t-15-4.5q-12 12-24.5 23.5T675-200l52 120h-74l-38-88q-14 6-27 10.5t-27 7.5q-5 29-27.5 49.5T481-80q-30 0-52.5-20T401-150q-15-3-28.5-7.5T345-168l-38 88h-74Zm76-174 62-140q-14-18-22-40t-8-46q0-57 41.5-98.5T481-620q57 0 98.5 41.5T621-480q0 24-8.5 47T589-392l62 138q9-8 17.5-14.5T685-284q-5-8-6.5-17.5T677-320q0-32 22-55t54-25q6-20 9-39.5t3-40.5q0-21-3-41.5t-9-40.5q-32-2-54-25t-22-55q0-9 2.5-17.5T685-676q-29-29-64-49t-74-31q-11 17-28 26.5t-38 9.5q-21 0-38-9.5T415-756q-41 11-76 31.5T275-674q3 8 5.5 16.5T283-640q0 32-21 54.5T209-560q-6 20-9 39.5t-3 40.5q0 21 3 40.5t9 39.5q32 2 53 25t21 55q0 9-1.5 17.5T275-286q8 9 16.5 16.5T309-254Zm60 34q11 5 22.5 9t23.5 7q11-17 28-26.5t38-9.5q21 0 38 9.5t28 26.5q12-3 22.5-7t21.5-9l-58-130q-12 5-25 7.5t-27 2.5q-15 0-28.5-3t-25.5-9l-58 132Zm112-200q24 0 42-17t18-43q0-24-18-42t-42-18q-26 0-43 18t-17 42q0 26 17 43t43 17Zm0-60Z" /></svg>,
            name: 'Activities',
                link: '/suggestions/'
            },
       /*  {
            icon: <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="16px" fill="#000000"><path d="M40-200v-600h80v400h320v-320h320q66 0 113 47t47 113v360h-80v-120H120v120H40Zm240-240q-50 0-85-35t-35-85q0-50 35-85t85-35q50 0 85 35t35 85q0 50-35 85t-85 35Zm240 40h320v-160q0-33-23.5-56.5T760-640H520v240ZM280-520q17 0 28.5-11.5T320-560q0-17-11.5-28.5T280-600q-17 0-28.5 11.5T240-560q0 17 11.5 28.5T280-520Zm0-40Zm240-80v240-240Z" /></svg>,
            name: 'Hotels',
            link: '/suggestions/hotels'
        },
        {
            icon: <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="16px" fill="#000000"><path d="M240-200v40q0 17-11.5 28.5T200-120h-40q-17 0-28.5-11.5T120-160v-320l84-240q6-18 21.5-29t34.5-11h440q19 0 34.5 11t21.5 29l84 240v320q0 17-11.5 28.5T800-120h-40q-17 0-28.5-11.5T720-160v-40H240Zm-8-360h496l-42-120H274l-42 120Zm-32 80v200-200Zm100 160q25 0 42.5-17.5T360-380q0-25-17.5-42.5T300-440q-25 0-42.5 17.5T240-380q0 25 17.5 42.5T300-320Zm360 0q25 0 42.5-17.5T720-380q0-25-17.5-42.5T660-440q-25 0-42.5 17.5T600-380q0 25 17.5 42.5T660-320Zm-460 40h560v-200H200v200Z" /></svg>,
            name: 'Car Rentals',
                link: '/suggestions/car-rentals'
        }, */
        {
            icon: <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="16px" fill="#000000"><path d="M280-80v-100l120-84v-144L80-280v-120l320-224v-176q0-33 23.5-56.5T480-880q33 0 56.5 23.5T560-800v176l320 224v120L560-408v144l120 84v100l-200-60-200 60Z" /></svg>,
            name: 'Flights',
            link: '/suggestions/flights'
        }/* ,
        {
            icon: <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="16px" fill="#000000"><path d="m175-120-56-56 410-410q-18-42-5-95t57-95q53-53 118-62t106 32q41 41 32 106t-62 118q-42 44-95 57t-95-5l-50 50 304 304-56 56-304-302-304 302Zm118-342L173-582q-54-54-54-129t54-129l248 250-128 128Z" /></svg>,
            name: 'Food & Drink',
            link: '/suggestions/food'
        },
        {
            icon: <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="16px" fill="#000000"><path d="M200-80v-800h80v80h560l-80 200 80 200H280v320h-80Zm80-640v240-240Zm220 200q33 0 56.5-23.5T580-600q0-33-23.5-56.5T500-680q-33 0-56.5 23.5T42₀-6₀₀q₀ 33 23.5 56.5T5₀₀-5₂₀Zm-2₂₀ 4₀h44₂l-48-1₂₀ 48-1₂₀H28₀v24₀Z" /></svg>,
            name: 'Tours',
            link: '/suggestions/tours'
        }, */
    ];

    const performSearch = async (query) => {
        // 1. Cancel any previous request still in progress
        if (abortControllerRef.current) {
            abortControllerRef.current.abort();
        }

        const trimmed = (query || '').trim();

        // 2. Handle Empty Search
        if (trimmed === '') {
            props.getSuggestions(); // Reverts to plain suggestions
            setSearchLoading(false);
            return;
        }

        // 3. Create a new controller for this specific request
        const controller = new AbortController();
        abortControllerRef.current = controller;

        setSearchLoading(true);


        try {
            const url = `${API_URL}/suggestions/search?q=${encodeURIComponent(trimmed)}`;
            const response = await fetch(url, {
                method: 'GET',
                credentials: 'include',
                headers: { 'Content-Type': 'application/json' },
                signal: controller.signal // <--- Pass the signal here!
            });

            if (!response.ok) throw new Error(`Search failed`);




            const data = await response.json();

            // If we reached here, this is the most current search result
            props.setSuggestions(data.results || []);
            props.setNextPageToken({ type: "textsearch", value: data.next_page_token || null });


             // 2. Cache Logic
            const cacheKey = `suggestionsCache${currentTripId}`;
            const existingCache = JSON.parse(localStorage.getItem(cacheKey) || "{}");

            // ALWAYS merge and deduplicate the data
            const merged = [...(existingCache.data || []), ...data.results];
            const deduped = [...new Map(merged.map(item => [item.place_id, item])).values()];

           
            

            const updatedCache = {
                data: deduped, // Data is always updated
                timestamp: existingCache.timestamp || Date.now(),
                token: existingCache.token || null
            };

            localStorage.setItem(cacheKey, JSON.stringify(updatedCache));


        } catch (err) {
            // Ignore "AbortError" because we caused it on purpose
            if (err.name === 'AbortError') {
                console.log('Previous search request cancelled');
                return;
            }

            // Fallback local filter logic remains the same
            const q = trimmed.toLowerCase();
            const filtered = (props.suggestions || []).filter(act => {
                const name = (act.name || act.title || '').toLowerCase();
                return name.includes(q);
            });
            props.setSuggestions(filtered);
        } finally {
            // Only stop loading if this was the latest controller
            if (abortControllerRef.current === controller) {
                setSearchLoading(false);
            }
        }
    };

    // Clean up on unmount
    useEffect(() => {
        return () => {
            if (abortControllerRef.current) abortControllerRef.current.abort();
        };
    }, []);

    useEffect(() => {
        const timer = setTimeout(() => {
            performSearch(props.searchQuery);
        }, 400);

        return () => clearTimeout(timer);
    }, [props.searchQuery]);



    return (
        <>
            {/* 1. Top Navigation Categories */}
            <div className={`${styles.categoryNavSection} ${!showCategories ? styles.categoryNavHidden : ''}`}>
                <div className={styles.categoryPills}>
                    {mainCategories.map((cat, index) => (
                        <Link to={cat.link}
                            key={index}
                            className={`${styles.navPill} ${cat.name === 'Activities' ? styles.activePill : ''}`}
                        >
                            {cat.icon}
                            <span className={styles.categoryName}>{cat.name}</span>
                        </Link>
                    ))}
                </div>
                <button onClick={() => setShowCategories(false)} className={styles.hideCategoriesBtn}>
                    <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#000000"><path d="m256-200-56-56 224-224-224-224 56-56 224 224 224-224 56 56-224 224 224 224-56 56-224-224-224 224Z" /></svg>
                </button>
            </div>
            {/* 2. Page Title Section */}
            <div className={styles.pageTitleSection}>
                <div className={styles.pageHeaderGroup}>
                    <div className={styles.titleRow}>
                        <p className={styles.pageTitle}>Suggested Activities</p>
                        {!showCategories && (


                            <button onClick={() => setShowCategories(true)} className={styles.showCategoriesBtn}>


                                <span className="material-symbols-outlined !text-lg">widgets</span>
                                Show Categories
                            </button>
                        )}
                    </div>
                    <p className={styles.pageSubtitle}>Discover and add new experiences to your itinerary</p>
                </div>
            </div>

            {/* 3. Sticky Controls Section */}
            <div className={styles.stickyControls}>
                <div className={styles.searchAndSort}>
                    <div className={styles.searchBar}>

                        <svg className={styles.searchIcon} xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#333333b3"><path d="M784-120 532-372q-30 24-69 38t-83 14q-109 0-184.5-75.5T120-580q0-109 75.5-184.5T380-840q109 0 184.5 75.5T640-580q0 44-14 83t-38 69l252 252-56 56ZM380-400q75 0 127.5-52.5T560-580q0-75-52.5-127.5T380-760q-75 0-127.5 52.5T200-580q0 75 52.5 127.5T380-400Z" /></svg>
                        <input
                            className={styles.searchInput}
                            placeholder="Search activities (e.g., 'Eiffel Tower')"
                            type="text"
                            value={props.searchQuery}
                            onChange={(e) => props.setSearchQuery(e.target.value)}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                    // trigger immediate filter
                                    props.setSearchQuery(prev => prev.trim());
                                }
                            }}
                        />
                        {props.searchQuery && (
                            <button aria-label="Clear search" className={styles.clearSearchBtn} onClick={() => props.setSearchQuery('')}>
                                &#215;
                            </button>
                        )}
                        {searchLoading && <div className={styles.searchSpinner}>Searching...</div>}
                    </div>
                    <div className={styles.sortAndFilterGroup}>
                        {/* Toggle Sidebar Button */}
                        <button
                            className={`${styles.filterButton} ${props.showFilters ? styles.filterButtonActive : ''}`}
                            onClick={() => props.setShowFilters(!props.showFilters)}
                        >

                            <span className="material-symbols-outlined">tune</span>
                            <span>Filters</span>

                            {props.activeFilters && (
                                <span className={styles.filterBadge} aria-hidden="true">{1}</span>
                            )}
                        </button>

                        <div className={styles.dropdown}>
                            <button className={styles.sortButton}>
                                <span>Sort by: {sortOptions.find(o => o.id === props.sortBy).name}</span>

                                <svg className={styles.dropdownIcon} xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#000000"><path d="M480-344 240-584l56-56 184 184 184-184 56 56-240 240Z" /></svg>

                            </button>
                            {/* Dropdown content omitted for brevity */}



                            <div className={styles.dropdownMenu}>
                                {sortOptions.map(option =>
                                    <div key={option.id} onClick={() => props.setSortBy(option.id)} ><span className="material-symbols-outlined !text-base">{option.icon}</span>{option.name}
                                        {option.icon_2 && <span className="material-symbols-outlined !text-base">{option.icon_2}</span>}
                                    </div>

                                )}


                            </div>


                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}